import React from "react"
import { Box } from "@mui/material"
import { AppAntSwitch } from "@components"
import { AppAcrissAutocomplete } from "@components/Autocomplete"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeOriginalData } from "Pages/AutoEuropeTool/Page/@signals"
import { enrichFilterIds } from "Pages/AutoEuropeTool/Page/@utils/filterEnrich"

export default function AutoEuropeFilterAcriss() {
	const d = autoEuropeDrawerData.peek()
	const { dataInfo: acrissInfo, setDataInfo: setAcriss } = useAutoEuropeDataInfo(d.filterAcriss ?? [])
	const { dataInfo: exclInfo, setDataInfo: setExcl } = useAutoEuropeDataInfo(d.filterAcrissExclusion ?? false)

	const isExclusion = exclInfo.value
	const acriss = acrissInfo.value ?? []

	return (
		<Box>
			<AppAntSwitch
				falseText="Include acriss"
				trueText="Exclude acriss"
				falseIcon="circle-check"
				trueIcon="ban"
				checked={isExclusion}
				onChange={e => setExcl(e.target.checked, 'filterAcrissExclusion')}
				chipSx={{ mb: 1.5 }}
			/>
			<AppAcrissAutocomplete
				label={isExclusion ? 'Exclude Acriss' : 'Include Acriss'}
				placeholder={isExclusion ? 'No acriss excluded' : 'No acriss included'}
				value={acriss.map(o => o?.value ?? o)}
				onChange={(_, opts) => setAcriss(opts ?? [], 'filterAcriss')}
				onAjax={options => { enrichFilterIds('filterAcriss', options, autoEuropeDrawerData, autoEuropeOriginalData); return options }}
			/>
		</Box>
	)
}